// correlated leak pin (leak detection) -> simulatable AquaFlow leak on the nearest water pipe
import { pipeLatLngs } from './model';
import { mkLeak } from './aquaTrain';

const water = (p) => p.type === 'water' || !p.type;
export function nearestPipe(project, pt) {
  const k = Math.cos((pt[0] * Math.PI) / 180), F = project.fittings || [];
  let best = null;
  for (const p of (project.pipes || []).filter(water)) {
    const P = pipeLatLngs(p, F);
    for (let i = 1; i < P.length; i += 1) {
      const ax = P[i - 1][1] * k, ay = P[i - 1][0], bx = P[i][1] * k, by = P[i][0], px = pt[1] * k, py = pt[0];
      const L2 = (bx - ax) ** 2 + (by - ay) ** 2, u = L2 ? Math.max(0, Math.min(1, ((px - ax) * (bx - ax) + (py - ay) * (by - ay)) / L2)) : 0;
      const d = Math.hypot(px - (ax + u * (bx - ax)), py - (ay + u * (by - ay))) * 111320;
      if (!best || d < best.d) best = { d, pipe: p, at: [ay + u * (by - ay), (ax + u * (bx - ax)) / k] };
    }
  }
  return best;
}

// returns the leak fitting for the target project (same id when the project is shared, new id for the original of a copy)
export function aquaLeak(target, leak, sameId) {
  const hit = nearestPipe(target, [leak.lat, leak.lon]);
  if (!hit || hit.d > 30) return null;
  const f = mkLeak(target, hit.at, hit.pipe, leak.name, { ...(leak.hyd || {}), leakOn: true, lmode: leak.hyd?.lmode || 'fixed', lq: leak.hyd?.lq ?? 0.5, ld: leak.hyd?.ld ?? 5 });
  return { ...leak, ...f, id: sameId ? leak.id : f.id, note: leak.note, corr: leak.corr, media: leak.media || [], memos: leak.memos || [], aquaAt: Date.now(), origAt: leak.origAt || [leak.lat, leak.lon] };
}
